/* eslint-disable react-hooks/rules-of-hooks */
import {
  Identify,
  identify,
  init,
  logEvent,
  setSessionId,
  setUserId,
  track,
} from "@amplitude/analytics-browser";

class AnalyticsClass {
  // idle logout timer set to 15 minutes
  public idleLogoutTimer: any;
  public idleAlertModalTimer: any;
  public titleInterval: any;

  /**
   * Initialise amplitude
   */
  setInitAmplitude = async () => {
    init(process.env.REACT_APP_ANALYTIC_KEY ?? "");
    setUserId("Guest");
    // setSessionId(Date.now());
  };

  /**
   * Set amplitude data for logged in user
   * @param data - Data to be set in amplitude
   */
  setAmplitudeUser = async (data: any) => {
    console.log("setamp");
    setUserId(data.user_name);

    const identifyObj = new Identify();
    identifyObj.set("ROLE_ID", data.role_id);
    identifyObj.set("ROLE_NAME", data.role_name);
    identify(identifyObj);
  };

  emitEvent = async (
    amplitudeKey: any,
    obj: { module?: string; activity?: string },
    property: any = null,
    userId: any = null
  ) => {
    try {
      let ObjAmp = {
        Module: obj?.module,
        Activity: obj?.activity,
        EnvironMent: process.env.REACT_APP_ENV,
      };

      if (property != null) {
        Object.assign(ObjAmp, property);
      }
      if (userId) {
        track(amplitudeKey, ObjAmp, { user_id: userId });
        logEvent(amplitudeKey, ObjAmp, { user_id: userId });
      } else {
        track(amplitudeKey, ObjAmp);
        logEvent(amplitudeKey, ObjAmp);
      }
    } catch (error) {
      console.error(error);
    }
  };
}

const triggerAnalyticsClient = new AnalyticsClass();
export default triggerAnalyticsClient;
